import React, { useState } from 'react';
import { Card, Checkbox, Col, Input, Row, Space, Typography } from 'antd';
import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';

const { Text, Title } = Typography;
const { TextArea } = Input;

interface TraduccionScSpProps {
  item: any;
}

// Texto mock traducido
const MOCK_TRANSLATED_TEXT = `Hello! I'm sending you many greetings. I hope you are doing very well.

I'm happy because I already turned 9 years old. Here in the countryside it's very sunny and I like to go out and play after doing my homework.

I want to tell you that my mom lets me take care of the hens and I feed them corn. I also have a dog named Manchas, and he follows me when I go get firewood with my dad. To get to school, I walk along a path where there are many mango trees. I sometimes eat one on the way!

Thank you for helping me with my school supplies. I really like my new notebook because it's blue.

Do you like animals? I'm drawing my dog Manchas here so you can meet him.

With much affection,
Esteban`;

const TraduccionScSp: React.FC<TraduccionScSpProps> = ({ item }) => {
  const [obsChecked, setObsChecked] = useState(false);
  const [obsText, setObsText]       = useState('');
  const [zoom, setZoom]             = useState(1);

  return (
    <Row gutter={[16, 16]} style={{ minHeight: 500 }}>

      {/* ── Columna izquierda: Comunicación original ── */}
      <Col span={24} md={12}>
        <Card
          title={<Text strong>Comunicación original</Text>}
          bodyStyle={{ padding: 12 }}
          style={{ height: '100%' }}
        >
          {/* Imagen de la carta (placeholder) */}
          <div
            style={{
              border: '2px dashed #d9d9d9',
              borderRadius: 4,
              background: '#fafafa',
              minHeight: 340,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transform: `scale(${zoom})`,
              transformOrigin: 'top center',
              transition: 'transform 0.2s',
              overflow: 'hidden',
            }}
          >
            <Text type="secondary" style={{ fontSize: 13 }}>
              [ Imagen de la carta ]
            </Text>
          </div>

          {/* Controles de imagen */}
          <Row justify="center" align="middle" style={{ marginTop: 12 }} gutter={16}>
            <Col>
              <Space size={16}>
                <SearchOutlined
                  style={{ fontSize: 18, cursor: 'pointer' }}
                  onClick={() => setZoom(z => Math.min(z + 0.1, 2))}
                />
                <MinusCircleOutlined
                  style={{ fontSize: 18, cursor: 'pointer' }}
                  onClick={() => setZoom(z => Math.max(z - 0.1, 0.5))}
                />
                <PlusCircleOutlined
                  style={{ fontSize: 18, cursor: 'pointer' }}
                  onClick={() => setZoom(z => Math.min(z + 0.1, 2))}
                />
                <LeftOutlined  style={{ fontSize: 18, cursor: 'pointer' }} />
                <RightOutlined style={{ fontSize: 18, cursor: 'pointer', color: '#1677ff' }} />
              </Space>
            </Col>
          </Row>
        </Card>
      </Col>

      {/* ── Columna derecha: Texto traducido con IA ── */}
      <Col span={24} md={12}>
        <Card
          title={<Text strong>Texto traducido con IA</Text>}
          bodyStyle={{ padding: 16 }}
          style={{ height: '100%' }}
        >
          {/* Metadatos */}
          <Row gutter={[8, 4]} style={{ marginBottom: 12 }}>
            <Col span={12}>
              <Text strong>SC# </Text>
              <Text>{item?.nroSc ?? '12245'}</Text>
            </Col>
            <Col span={12}>
              <Text strong>NO - SP# </Text>
              <Text type="secondary">-008 122456</Text>
            </Col>
            <Col span={12}>
              <Text strong style={{ color: '#1677ff' }}>SC Nombre </Text>
              <Text style={{ color: '#1677ff' }}>{item?.nombreSc ?? 'Esteban Juárez'}</Text>
            </Col>
            <Col span={12}>
              <Text strong style={{ color: '#1677ff' }}>SP Nombre </Text>
              <Text style={{ color: '#1677ff' }}>Mr. Smith</Text>
            </Col>
            <Col span={24}>
              <Text strong>Com Ref: </Text>
              <Text>1234577</Text>
            </Col>
          </Row>

          {/* Texto traducido */}
          <div
            style={{
              borderTop: '1px solid #f0f0f0',
              paddingTop: 12,
              marginBottom: 16,
              maxHeight: 240,
              overflowY: 'auto',
              whiteSpace: 'pre-line',
              fontSize: 13,
              lineHeight: 1.7,
            }}
          >
            {MOCK_TRANSLATED_TEXT}
          </div>

          {/* Observaciones del traductor */}
          <div>
            <Checkbox
              checked={obsChecked}
              onChange={e => setObsChecked(e.target.checked)}
            >
              <Text strong>Observaciones del traductor</Text>
            </Checkbox>
            {obsChecked && (
              <TextArea
                rows={3}
                style={{ marginTop: 8 }}
                placeholder="Ingrese sus observaciones..."
                value={obsText}
                onChange={e => setObsText(e.target.value)}
              />
            )}
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default TraduccionScSp;
